<!-- 页面按钮组组件 -->
<template>
  <div class="content">
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <!-- 渲染普通按钮 -->
        <template v-for="(item, index) in BTNDATA">
          <template v-if="!item.type">
            <el-button class="glo_btnItems" v-if="hasPermiss(item.permissVal) ||!item.permissVal" :key="index" @click="callBack(item.method)">{{ item.name }}</el-button>
          </template>
          <!-- 渲染多选择按钮 -->
          <template v-else>
            <el-dropdown class="topDropDown" :key="index" @command="topCommandBtns">
              <el-button type="primary">
                {{ item.name }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(option, num) in item.options" :command="option.handleName" :key="num">{{ option.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </template>
      </div>
      <div class="glo_btnList_right">
        <el-button class="glo_bgcMainColor" @click="queryBtn_ok" icon="el-icon-search">查询</el-button>
        <el-tooltip content="清空查询条件" placement="top">
          <div class="textBtn" @click="clearBtns">清除</div>
        </el-tooltip>
        <el-tooltip content="展开收起更多条件" placement="top">
          <div class="textBtn" @click="moreParam">{{ message }}</div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    btndata: {
      type: Array,
    },
  },
  emits: ["btnEvent", "clearBtns", "moreParam", "queryBtn_ok", "moreHandle"],
  data() {
    return {
      // 按钮数据
      BTNDATA: this.btndata,
      // 更多搜索按钮控制
      HaseMore: false,
      // 更多搜索文本
      message: "更多条件",
    };
  },
  methods: {
    // 按钮事件
    callBack(param) {
      let flag = typeof param;
      if (flag == "object") {
        // this.$confirm(param.title, "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "warning",
        // })
        //   .then(() => {
        this.$emit("btnEvent", param.methodname);
        // })
        // .catch(() => {});
      } else {
        this.$emit("btnEvent", param);
      }
    },
    // 按钮更多操作
    topCommandBtns(e) {
      this.$emit("moreHandle", e);
    },
    // 更多搜索按钮
    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.message = "收起条件";
      } else {
        this.message = "更多条件";
      }
      this.$emit("moreParam", this.isHaseMore);
    },
    // 查询事件
    queryBtn_ok() {
      this.$emit("queryBtn_ok");
    },
    //   清空
    clearBtns() {
      this.$confirm("是否清空查询条件?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("clearBtns");
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" >
</style>
